import React from 'react';
export const TeamSection = () => {
  return <section id="team" className="py-16 bg-slate-50" data-id="element-255">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
        <div className="lg:text-center" data-id="element-257">
          <h2 className="text-base text-[#D4AF37] font-semibold tracking-wide uppercase" data-id="element-258">
            Our Team
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-800 sm:text-4xl" data-id="element-259">
            Meet the Experts
          </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-600 lg:mx-auto" data-id="element-260">
            Our team combines decades of experience with innovative thinking to
            deliver exceptional results.
          </p>
        </div>
        <div className="mt-16 flex flex-col items-center justify-center" data-id="element-261">
          <div className="bg-white p-10 rounded-lg shadow-sm text-center max-w-2xl" data-id="element-262">
            <p className="text-2xl font-bold text-[#D4AF37]" data-id="element-263">Coming Soon</p>
            <p className="mt-4 text-slate-600" data-id="element-264">
              We're in the process of introducing our expert team members who
              bring decades of experience in the Indian market. Check back soon
              to meet the investment professionals behind Aurum Grove Capital's
              success.
            </p>
          </div>
        </div>
      </div>
    </section>;
};